import actions from './actions'
import * as types  from './types'
import getters from './getters'

const state = {
  herePlatform: null,
  hereRouting: null,
  hereDefaultLayer: null,
  hereMarkers: null,
  hereMap: null,
  hereMapBehaviors: null,
  isInitializing: false,
  isRouting: false,
  routingOptions: null,
  routingMarkers: null

}
const initialState = {
  herePlatform: null,
  hereRouting: null,
  hereDefaultLayer: null,
  hereMarkers: null,
  hereMap: null,
  hereMapBehaviors: null,
  isInitializing: false,
  isRouting: false,
  routingOptions: null,
  routingMarkers: null

}

const mutations = {
  [types.SET_IS_MAP_INITIALIZING](state, action) {
    state.isInitializing = action.flag
  },
  [types.SET_IS_MAP_ROUTING](state, action) {
    state.isRouting = action.flag
  },
  [types.SET_HERE_MAPS_PLATFORM](state, action) {
    state.herePlatform = {...action.platform }
  },
  [types.SET_HERE_MAPS_ROUTING](state, action) {
    state.hereRouting = { ...action.routing }
  },
  [types.SET_HERE_MAPS_DEFAULT_LAYER](state, action) {
    state.hereDefaultLayer = { ...action.defaultLayer }
  },
  [types.SET_HERE_MAPS_MAP](state, action) {
    state.hereMap = { ...action.map }
  },
  [types.SET_HERE_MAPS_MAP_BEHAVIORS](state, action) {
    state.hereMapBehaviors = { ...action.mapBehaviors }
  },
  [types.SET_HERE_MAPS_MARKERS](state, action) {
    state.hereMarkers = { ...action.markers }
  },
  [types.SET_MAP_ROUTING_OPTIONS_MARKERS](state, action) {
    state.routingOptions = action.routingOptions
    state.routingMarkers = action.routingMarkers
  },
  [types.SET_RESET_STATE] (state, action) {
    Object.assign(state, initialState)
  }
}

export const shipmentsMap = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
